module.exports = __webpack_public_path__ + "img/banner2_4New.8d1e935b.png";